import React from 'react';

export const Alert = ({ variant = 'primary', className = '', children, ...props }) => {
  const variantClass = variant === 'destructive' ? 'alert-danger' : `alert-${variant}`;
  
  return (
    <div className={`alert ${variantClass} ${className}`} role="alert" {...props}>
      {children}
    </div>
  );
};

export const AlertDescription = ({ className = '', children, ...props }) => {
  return (
    <div className={`${className}`} {...props}>
      {children}
    </div>
  );
};